import classNames from "classnames";
import { ChangeEvent } from "react";

import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  makeStyles
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    width: "200px"
  }
}));

export default function CsvColumnSelect({
  value,
  options,
  onChange,
  id,
  className,
  dataSourceFieldLabel,
  withNoneOption = true
}: {
  value: string | null;
  options: string[];
  onChange: (value: string | null) => any;
  id: string;
  className?: string;
  dataSourceFieldLabel: string;
  withNoneOption?: boolean;
}): JSX.Element {
  const classes = useStyles();

  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    onChange((event.target.value as string) || null);
  };

  const labelId = `${id}-csv-column-select`;

  // TODO: use components/forms/Select
  return (
    <FormControl className={classNames(classes.container, className)}>
      <InputLabel shrink id={labelId}>
        {dataSourceFieldLabel}
      </InputLabel>
      <Select
        id={id}
        value={value || ""}
        onChange={handleChange}
        label={dataSourceFieldLabel}
        labelId={labelId}
        displayEmpty
      >
        {withNoneOption ? (
          <MenuItem value="">
            <em>Not mapped to a column</em>
          </MenuItem>
        ) : null}
        {options.map(name => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
